import { GroupMembershipsResponseSchema, GroupResponseDto, GroupUpdateDto, } from '@lucidlink/dto/web-service-api';
import { arrayParserFromDto, parserFromDto } from '#fetcher/parse-utils';
import { prepareBulkAddGroupsMembershipsDto } from './prepare-add-group-member-dto';
import { prepareCreateGroupDto } from './prepare-create-group-dto';
export { GroupManagementError } from './group-manager-errors';
export const createGroupManager = ({ workspaceId, workspaceFetcher, groupsMap, getAdminCrypto, getPrincipalsCrypto, loginToWorkspace, }) => {
    return new GroupManagerImpl(workspaceId, workspaceFetcher, groupsMap, getAdminCrypto, getPrincipalsCrypto, loginToWorkspace);
};
class GroupManagerImpl {
    workspaceId;
    workspaceFetcher;
    groupsMap;
    getAdminCrypto;
    getPrincipalsCrypto;
    loginToWorkspace;
    groupsFetcher;
    constructor(workspaceId, workspaceFetcher, groupsMap, getAdminCrypto, getPrincipalsCrypto, loginToWorkspace) {
        this.workspaceId = workspaceId;
        this.workspaceFetcher = workspaceFetcher;
        this.groupsMap = groupsMap;
        this.getAdminCrypto = getAdminCrypto;
        this.getPrincipalsCrypto = getPrincipalsCrypto;
        this.loginToWorkspace = loginToWorkspace;
        this.groupsFetcher = this.workspaceFetcher.createSubFetcher({
            path: 'groups',
        });
    }
    async createGroup(name) {
        await this.loginToWorkspace();
        const adminCrypto = await this.getAdminCrypto();
        const createDto = await prepareCreateGroupDto({
            adminCrypto,
            workspaceId: this.workspaceId,
            name,
        });
        const res = await this.groupsFetcher.post([], {
            body: createDto,
            parser: parserFromDto(GroupResponseDto),
        });
        (await this.getPrincipalsCrypto()).refresh();
        await this.groupsMap.refresh();
        return res;
    }
    async listGroups() {
        await this.loginToWorkspace();
        await this.getAdminCrypto();
        return await this.groupsFetcher.get([], {
            parser: arrayParserFromDto(GroupResponseDto),
        });
    }
    async getGroup(principalId) {
        await this.loginToWorkspace();
        await this.getAdminCrypto();
        return await this.groupsFetcher.get(principalId, {
            parser: parserFromDto(GroupResponseDto),
        });
    }
    async deleteGroup(principalId) {
        await this.loginToWorkspace();
        await this.getAdminCrypto();
        await this.groupsFetcher.delete(principalId);
        (await this.getPrincipalsCrypto()).refresh();
        await this.groupsMap.refresh();
    }
    async renameGroup(principalId, newName) {
        await this.loginToWorkspace();
        await this.getAdminCrypto();
        const updateDto = GroupUpdateDto.create({
            name: newName,
        });
        return await this.groupsFetcher.patch([principalId], {
            body: updateDto,
            parser: parserFromDto(GroupResponseDto),
        });
    }
    async listGroupMembers(principalId, options = {}) {
        await this.loginToWorkspace();
        await this.getAdminCrypto();
        return await this.groupsFetcher.get([principalId, 'members'], {
            queryParams: options,
            parser: (json) => GroupMembershipsResponseSchema.array().parse(json),
        });
    }
    async addToGroup(groupPrincipalId, memberPrincipalId) {
        await this.addManyMemberships([
            { groupId: groupPrincipalId, memberId: memberPrincipalId },
        ]);
    }
    async removeFromGroup(groupPrincipalId, memberPrincipalId) {
        await this.loginToWorkspace();
        await this.getAdminCrypto();
        await this.groupsFetcher.delete([
            groupPrincipalId,
            'member',
            memberPrincipalId,
        ]);
    }
    async addManyMemberships(memberships) {
        await this.loginToWorkspace();
        await this.getAdminCrypto();
        const principalsCrypto = await this.getPrincipalsCrypto();
        const requestBody = await prepareBulkAddGroupsMembershipsDto({
            principalsCrypto,
            memberships,
        });
        await this.groupsFetcher.put(['members'], {
            body: requestBody,
        });
    }
}
export * from './prepare-create-group-dto';
